import { useCallback, useRef } from 'react'
import type { TurnstileInstance } from '@marsidev/react-turnstile'

function useTurnstileToken() {
  const turnstileRef = useRef<TurnstileInstance>(null)
  const isReady = useRef(false)

  const reset = useCallback(() => {
    turnstileRef.current?.reset()
  }, [])

  const markReady = useCallback(() => {
    isReady.current = true
  }, [])

  async function requestToken() {
    if (!isReady.current || !turnstileRef.current) {
      throw new Error('Turnstile widget is not ready')
    }

    turnstileRef.current.reset()
    turnstileRef.current.execute()

    return turnstileRef.current.getResponsePromise()
  }

  return {
    turnstileRef,
    requestToken,
    markReady,
    reset,
  }
}

export { useTurnstileToken }
